import api from '@pray/shared/utils/api';

type GetStripeCustomerPortalParams = {
  artistId: string;
  query?: {
    return_url?: string;
  };
};

type StripeCustomerPortalResponse = {
  data: {
    url: string;
  };
};

export async function getStripeCustomerPortal({ artistId = '', query }: GetStripeCustomerPortalParams) {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/stripe-customer-portal`;
  const response = await api.executeGetRequest<StripeCustomerPortalResponse>(url, { query });

  // Extract the portal URL directly from the nested response
  return response.data?.data?.url;
}
